// @flow

import React from 'react';
import './SaveMenu.css';
import {Prompt} from 'react-router-dom';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';

export type Props = {
  isLoading?: boolean,
  onDiscard: Function,
  onSave: Function,
};

const SaveMenu = ({onSave, onDiscard, isLoading = false}: Props) => (
  <div className="SaveMenu">
    <div className="SaveMenu-inner-content">
      <div className="shrink column SaveMenu-text">
        <div>Du har osparade ändringar</div>
      </div>
      <div className="shrink column horizontal-button-list">
        <button
          className="button warning"
          type="button"
          onClick={() => onDiscard()}>
          Ångra
        </button>
        <button
          className="button success"
          type="button"
          onClick={() => onSave()}>
          Spara
        </button>
      </div>
    </div>
    <LoadingIndicator isLoading={isLoading} hideSpinner={true} />
    <Prompt message="Du har osparade ändringar, lämna ändå?" />
  </div>
);

export default SaveMenu;



// WEBPACK FOOTER //
// ./src/components/SaveMenu/SaveMenu.js